import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import SidebarNavLink from './SidebarNavLink';
import { getNavigationItems } from '../../../config/navigation';
import { useCacheBusterContext } from '../../CacheBuster';

const Sidebar = ({ onLinkOpen, user }) => {
    const navigationItems = getNavigationItems(user);

    const { refreshCacheAndReload, loading, isLatestVersion } = useCacheBusterContext();

    return (
        <div className="sidebar-background-image">
            <ul className="nav flex-column">
                {navigationItems.home && (
                    <SidebarNavLink onLinkOpen={onLinkOpen} icon="home" isVisible name="Home" link="/dashboard/home" />
                )}
                {navigationItems.companies && (
                    <SidebarNavLink
                        onLinkOpen={onLinkOpen}
                        icon="building"
                        isVisible
                        name="Companies"
                        link="/dashboard/companies"
                    />
                )}
                {navigationItems.calendar && (
                    <SidebarNavLink
                        onLinkOpen={onLinkOpen}
                        icon="calendar"
                        isVisible
                        name="Calendar"
                        link={`/calendar/month/${moment().year()}/${moment().month() + 1}/${moment().date()}`}
                    />
                )}
                {navigationItems &&
                    Object.entries(navigationItems)
                        .filter(([key, value]) => value.isNamedDashboard)
                        .map(([key, value]) => (
                            <SidebarNavLink
                                key={key}
                                onLinkOpen={onLinkOpen}
                                icon={value.icon}
                                isVisible
                                name={value.name}
                                link={`/dashboard/${key}`}
                            />
                        ))}
                {navigationItems.changePassword && (
                    <SidebarNavLink
                        onLinkOpen={onLinkOpen}
                        icon="key"
                        isVisible
                        name="Change Password"
                        link={`/changepassword`}
                    />
                )}
                {navigationItems.support && (
                    <SidebarNavLink
                        onLinkOpen={onLinkOpen}
                        icon="comment"
                        isVisible
                        name="Support"
                        link={`/support/request/`}
                    />
                )}
                {!loading && !isLatestVersion ? (
                    <div style={{ backgroundColor: '#F2F2F2', textAlign: 'center' }}>
                        <button
                            className="btn"
                            type="button"
                            onClick={() => refreshCacheAndReload()}
                            style={{
                                textAlign: 'center',
                                margin: '10px',
                                borderRadius: '0.5rem',
                                border: 'none',
                                backgroundColor: '#FFC107',
                                color: '#555',
                                padding: '7px'
                            }}
                        >
                            Update Available. Click to restart.
                        </button>
                    </div>
                ) : (
                    <></>
                )}
            </ul>
        </div>
    );
};

const mapStateToProps = state => ({ user: state.user });

export default connect(mapStateToProps, {})(Sidebar);
